import React from 'react';
import AllWorkListTable from './allWorkListTable';

const ActionTaken = () => {
  return (
<AllWorkListTable type="actionTaken"/>
  )
}

export default ActionTaken